import {
  getSettingsByType,
  upsertSettingsByType,
  updateSettingsById,
} from 'app/pages/MyautoiqSettingsPage/data/myautoiqSettingsRequestUtils';

const SETTINGS_TYPE = 'DEALER_SEGMENTS_CONFIG';

export const fetchMyautoiqSegmentSettings = async ({
  manufacturerId,
  makeId,
}: {
  manufacturerId: string;
  makeId?: string | null;
}): Promise<any> => {
  return getSettingsByType({ manufacturerId, makeId, type: SETTINGS_TYPE });
};

export const createMyautoiqSegmentSettings = async ({
  manufacturerId,
  makeId,
  data,
}: {
  manufacturerId: string;
  makeId?: string | null;
  data: any;
}): Promise<any> => {
  return upsertSettingsByType({
    manufacturerId,
    makeId,
    type: SETTINGS_TYPE,
    data,
  });
};

export const updateMyautoiqSegmentSettings = async ({
  manufacturerId,
  makeId,
  settingsId,
  data,
}: {
  manufacturerId: string;
  makeId?: string | null;
  settingsId: string;
  data: any;
}): Promise<any> => {
  return updateSettingsById({ manufacturerId, makeId, settingsId, data });
};
